// extracted by mini-css-extract-plugin
export default {"OperationItem":"lFYV4Ssq8JoY7WWNsnqV","IncomingOperation":"UnUpIcthMk3Bkg1Ym9Qi","OutgoingOperations":"URTZENGRtVabQu9Cyp8x"};